import { useRef } from "react";
import data from "./data.json";
import Nav from "./nav";
import Hero from "./Hero";
import Gallery from "./galery.jsx";
import Form from "./Form.jsx";
import Mentor from "./Mentor";
import Technologies from "./Technologies.jsx";
import Topics from "./Topics.jsx";
import Rating from "./Rating.jsx";
import Steps from "./Steps.jsx";
import Pricing from "./Pricing.jsx";
import Institute from "./Institute.jsx";
import Footer from "./Footer.jsx";
import TelegramBanner from "./TelegramBanner.jsx";
import ConsoleBlock from "./ConsoleBlock.jsx";
import Faq from "./Faq.jsx";


export default function Home() {
  const formRef = useRef(null);
  const { nav, hero, mentor, technologies, topics, rating, steps, pricing, institute, form: f, footer } = data;
  const scrollToForm = () => formRef.current?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="pb-20 md:pb-0">
      <ConsoleBlock />
      <Nav nav={nav} scrollToForm={scrollToForm} />

      <section id="home">
        <Hero hero={hero} scrollToForm={scrollToForm} />
      </section>

      {/* 1. Kurs mazmuni */}
      <section id="course">
        <Technologies technologies={technologies} />
      </section>
      <Topics topics={topics} />

      {/* 2. Jarayon */}
      <Steps steps={steps} />

      {/* 3. Insoniy omil va ishonch */}
      <section id="mentor">
        <Mentor mentor={mentor} />
      </section>
      <Gallery />
      <Institute institute={institute} />

      {/* 4. Ijtimoiy isbot va natija */}
      <Rating rating={rating} />

      {/* 5. Qaror qabul qilish */}
      <section id="pricing">
        <Pricing pricing={pricing} scrollToForm={scrollToForm} />
      </section>

      {/* 6. Yakuniy harakat */}
      <section id="faq">
        <Faq scrollToForm={scrollToForm} />
      </section>

      {/* 7. Yakuniy harakat va ariza*/}
      <Form f={f} formRef={formRef} />


      <TelegramBanner />
      <Footer footer={footer} />
    </div>
  );
}